import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { SortOrder } from '@/types/common'
import { DEFAULT_PAGE, SortDirection, TABLE_PAGE_SIZE } from '@/utils/constants'

import { CommentFilters } from './types'

interface CommentState {
  searchText: string
  filters: CommentFilters
  page: number
  rowsPerPage: number
  sort: {
    column: string | null
    direction: SortOrder
  }
}

interface CommentActions {
  setSearchText: (searchText: string) => void
  setFilter: (filters: Partial<CommentFilters>) => void
  setPage: (page: number) => void
  setSort: (sort: { column: string | null; direction: SortOrder }) => void
  reset: () => void
}

const initialState: CommentState = {
  searchText: '',
  filters: {
    searchText: '',
    deliverableSetId: null,
    projectIds: [],
    tflFileId: null,
    status: null,
    reviewStatus: null,
    action: null,
  },
  page: DEFAULT_PAGE,
  rowsPerPage: TABLE_PAGE_SIZE,
  sort: {
    column: null,
    direction: null,
  },
}

export const useCommentsStore = create<CommentState & CommentActions>()(
  devtools(
    (set) => ({
      ...initialState,

      setSearchText: (searchText: string) => {
        set({ searchText }, false, 'setSearchText')
      },

      setFilter: (newFilters: Partial<CommentFilters>) => {
        set(
          (state) => ({
            filters: { ...state.filters, ...newFilters },
          }),
          false,
          'setFilter'
        )
      },

      setPage: (page: number) => {
        set({ page }, false, 'setPage')
      },

      setSort: (sort: { column: string | null; direction: SortDirection }) => {
        set({ sort }, false, 'setSort')
      },

      reset: () => {
        set(initialState, false, 'reset')
      },
    }),
    {
      name: 'CommentsStore',
    }
  )
)
